import { format } from 'date-fns';
import Breadcrumb from '~/components/Breadcrumbs/Breadcrumb';
import Panel from '~/components/Panel';
import MedicalProfessionalPanel from '~/components/MedicalProfessionalDetail/MedicalProfessionalPanel';
import Referrals from '~/components/VendorDetail/Referrals';
import NotesPanel from '~/components/MedicalProfessionalDetail/NotesPanel';
import { MdCheck } from 'react-icons/md';

const VendorDetail = () => {
  return (
    <>
      <Breadcrumb pageName='Vendor or Organization Detail' />

      <Panel>
        <div className='flex justify-between'>
          <div>
            <div className='flex'>
              <h1 className='text-[38px]/[44px]'>Vendor or Organization</h1>
              <div className='ml-[15px] mt-[10px] w-[16px]'>
                <MdCheck color='#949599' size={20} />
              </div>
            </div>

            <div className='flex'>
              <div className='inline-flex rounded-3xl bg-primary px-2 py-1 text-[12px]/[14.4px]'>
                Active
              </div>
              <div className='ml-[15px] text-[16px]/[24px] text-[#949599]'>
                Last Updated: {format(new Date(), 'LL/dd/yy')}
              </div>
            </div>
          </div>
        </div>
      </Panel>

      <div className='flex'>
        <div className='w-3/4 pr-[10px] pt-[20px]'>
          <div className='mb-7.5'>
            <MedicalProfessionalPanel />
          </div>

          <Panel>
            <h2 className='mb-5 text-xl font-semibold text-black dark:text-white'>
              Referrals
            </h2>
            <Referrals />
          </Panel>
        </div>
        <div className='w-1/4 pl-[10px] pt-[20px]'>
          <Panel>
            <NotesPanel />
          </Panel>
        </div>
      </div>
    </>
  );
};

export default VendorDetail;
